import script from "./MockupDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./MockupDisplay.vue?vue&type=script&setup=true&lang=js"

import "./MockupDisplay.vue?vue&type=style&index=0&id=3cbe7cd7&lang=scss"

const __exports__ = script;

export default __exports__